var parser = {
	extractStreet: function(address) {
		return address ? String(address).replace(/\,\s?[0-9]+ (.*?)$/, '') : '';
	}
};

export default parser;